import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { t } from 'i18n-js';

import useBooleanState from '~/hooks/useBooleanState';
import useMobileNavigationScroll from '~/hooks/useMobileNavigationScroll';
import { MenuButton } from '~/routes/LootBoyContainer/TopNavigationBar/MenuButton';
import NavigationLink from '~/routes/LootBoyContainer/TopNavigationBar/NavigationLink';
import { COMICS_PATH, NEWS_PATH } from '~/routes/paths';

import { ReactComponent as Logo } from '~/assets/images/logo/logo-white.svg';

import AnimatedNavigation from './AnimatedNavigation';
import DailyBoostButton from './DailyBoostButton';
import TabNavigation from './TabNavigation';

import styles from './TopNavigationBar.module.scss';

export default function TopNavigationBar(): JSX.Element {
  const hide = useMobileNavigationScroll();

  const searchBooleanState = useBooleanState();
  const [search] = searchBooleanState;

  return (
    <>
      <TabNavigation
        hide={hide}
        search={search}
      />
      <nav
        className={classNames(styles.topNavigationBar, {
          [styles.hide]: hide,
          [styles.hideSearch]: search,
        })}
      >
        <Link
          to="/"
          className={styles.lootboyLogo}
        >
          <Logo />
        </Link>
        <NavigationLink to={NEWS_PATH}>{t('TopNav_news')}</NavigationLink>
        <NavigationLink to={COMICS_PATH}>{t('TopNav_comics')}</NavigationLink>
        <DailyBoostButton />
        <MenuButton className={styles.menu} />
        <AnimatedNavigation searchBooleanState={searchBooleanState} />
      </nav>
    </>
  );
}
